import { createSlice } from '@reduxjs/toolkit';
import initState from '../../../domain/entities/pay';

// GETBYID
function getById(state, action) {
  state.getById.data = action.payload.data ? action.payload.data:[];
}

function conexionGetById(state, action) {
  state.getById.connection= action.payload.connection;
}

function errorGetById(state, action) {
  state.getById.error= action.payload.error ? action.payload.error:false;
  state.getById.message= action.payload.message ? action.payload.message:"";
}

function createGetByIdReset(state, action) {
  state.getById.data=[];
  state.getById.connection= false;
  state.getById.error= false;
  state.getById.message= "";
}

// CREATE
function create(state, action) {
  state.create.result = action.payload.result ? action.payload.result:false;
}

function conexionCreate(state, action) {
  state.create.connection= action.payload.connection;
}

function errorCreate(state, action) {
  state.create.error= action.payload.error ? action.payload.error:false;
  state.create.message= action.payload.message ? action.payload.message:"";
}

function createReset(state, action) {
  state.create.result=false;
  state.create.connection= false;
  state.create.error= false;
  state.create.message= "";
}



/**
 * Conexión
 */
const payReducer = createSlice({
  name: 'pay',
  initialState: initState,
  reducers: {
    // GETBYID
    getById,
    conexionGetById,
    errorGetById,
    createGetByIdReset,
    // CREATE
    create,
    conexionCreate,
    errorCreate,
    createReset,
  },
});

export const payActions = {
  ...payReducer.actions,
};

export default payReducer.reducer;
